export class IssueNewBusinessModel {
  PolicyTxnId: number;
  TransactionStatus: string;
  BalanceDue: number;
  SuspenseAmount: number;
  Status?: string;
  Errors?: Object[];
  Warnings?: Object[];
}
